<template>
  <div class="step-body step-done">
    <div class="done-burst">
      <div class="done-check">
        <svg viewBox="0 0 64 64" width="64" height="64">
          <circle cx="32" cy="32" r="30" fill="none" stroke="currentColor" stroke-width="3" class="done-circle"/>
          <polyline points="20 33 29 42 46 24" fill="none" stroke="currentColor" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round" class="done-tick"/>
        </svg>
      </div>
      <div class="done-rays">
        <span v-for="i in 12" :key="i" :style="{ transform: 'rotate(' + ((i - 1) * 30) + 'deg)' }"></span>
      </div>
    </div>

    <h2 class="done-title">ברוכים הבאים ל-Linktone, {{ data.artistName }}!</h2>
    <p class="done-sub">
      החשבון שלכם נוצר בהצלחה. נשלח אליכם מייל לאימות לכתובת <b dir="ltr">{{ data.email }}</b>.
      יש לאשר את המייל לפני שניתן להתחבר.
    </p>

    <div class="done-summary">
      <div class="done-summary-card">
        <img v-if="data.photo" :src="data.photo.url" alt="" class="done-avatar" />
        <div v-else class="done-avatar done-avatar-placeholder">{{ initial }}</div>
        <div class="done-summary-meta">
          <div class="done-summary-name">{{ data.artistName }}</div>
          <div class="done-summary-genres">
            <span v-for="name in selectedGenreNames" :key="name" class="done-chip">{{ name }}</span>
          </div>
          <div class="done-summary-stats">
            <span><LtIcon name="link" :size="14" /> {{ socialsCount }} קישורים</span>
            <span><LtIcon name="briefcase" :size="14" /> {{ contactsCount }} אנשי קשר</span>
          </div>
        </div>
      </div>
    </div>

    <div class="done-actions">
      <a :href="site_url" class="btn-primary">
        חזרה לדף הבית
        <LtIcon name="arrow-left" :size="18" />
      </a>
    </div>
  </div>
</template>

<script>
import LtIcon from './LtIcon.vue';
import { genreNamesForIds } from './data.js';

export default {
  name: 'StepDone',
  components: { LtIcon },
  props: { data: { type: Object, required: true } },
  computed: {
    socialsCount()  { return Object.values(this.data.socials || {}).filter(Boolean).length; },
    contactsCount() { return Object.values(this.data.contacts || {}).filter((c) => c && c.enabled).length; },
    initial()       { return (this.data.artistName || '?').slice(0, 1); },
    selectedGenreNames() {
      return genreNamesForIds(this.$store.genres, this.data.genres);
    },
  },
}
</script>
